<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Add Block Email Id</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">

          <form [formGroup]="blockContactForm" style="width: 100%;">
            <div class="content" fxLayout="column" fxLayoutGap="8px">
               <div formArrayName="emails">
        <div *ngFor="let item of blockContact.controls; let i = index">
            <div class="answerprt">
                <mat-form-field appearance="outline">
                  <mat-label>Block Email</mat-label>
                  <input
                    matInput
                    placeholder="Add Email Id"
                    formControlName="{{i}}"
                  />
                  <mat-error *ngIf="item.hasError('required')">
                    This is a required field.
                  </mat-error>
                  <mat-error *ngIf="item.hasError('pattern')">
                    Please enter valid email address.
                  </mat-error>
                </mat-form-field>
                <span
              (click)="removeField(i)"
              class="remove"
              *ngIf="blockContact.controls.length > 1"
              ><mat-icon>clear</mat-icon></span>
              </div>
        </div>
        <button
          type="button"
          mat-raised-button
          (click)="addField()"
          [disabled]="
            blockContactForm?.controls?.emails?.status === 'INVALID'
          "
        >
         <mat-icon>add_circle_outline</mat-icon> Add New Block Email Id
        </button>
      </div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
              <button mat-button type="button" class="sub-button" (click)="add()"><span>Add</span></button>
              <button mat-button type="button" class="can-button" (click)="location.back()"><span>Cancel</span></button>
            </div>
          </form>
    </div>
  </div>